import React from "react";
import Card from "@mui/material/Card";
import useClipboard from "react-use-clipboard";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface Props {
  header: string;
  description: string;
  src: string;
  footerText: string;
  currentSate: boolean;
  couponsCode: string;
  is_expired: boolean;
}

function CouponCard({
  header,
  description,
  src,
  footerText,
  currentSate,
  couponsCode,
  is_expired,
}: Props) {
  const [isCopied, setCopied] = useClipboard(couponsCode, {
    successDuration: 1000,
  });

  return (
    <Card
      className="flex flex-col bg-plainGreen cursor-pointer border-none shadow-none mb-2 w-full p-4"
      style={{ width: "100%" }}
    >
      {/* First row: Image */}
      <div className="flex justify-between items-center mb-2">
        <div className="flex items-center">
          {/* <img src={src} alt="Promotion icon" className="w-8 h-8" /> */}
          <span className="font-bold md:text-base text-base opacity-75">
            {header}
          </span>
        </div>

        <div>
          {" "}
          <span className="text-xs opacity-75 font-bold">
            {footerText} Points
          </span>
        </div>
      </div>

      {/* Second row: Header and button */}
      <div className="flex flex-col justify-between mb-2">
        <div className="flex  items-center">
          <span
            className="text-xs opacity-75 font-bold cursor-pointer"
            onClick={setCopied}
          >
            {isCopied ? "Copied!" : couponsCode}
          </span>
          <span className="pl-2 cursor-pointer" onClick={setCopied}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 text-gray-500"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M8 2a2 2 0 00-2 2v1H4a2 2 0 00-2 2v9a2 2 0 002 2h9a2 2 0 002-2v-2h1a2 2 0 002-2V6.5l-.006-.144A1.993 1.993 0 0017 5h-1V4a2 2 0 00-2-2H8zm2 3V4h4v1h-4zm5 3h1v2h-1V8zM3 8h10v9H4a1 1 0 01-1-1V8zm11 4v3H8a1 1 0 01-1-1v-3h7z" />
            </svg>
          </span>
        </div>
      </div>

      {/* Third row: Description and footer text */}
      <div className="flex flex-row justify-between items-center">
  <span className="text-xs opacity-75 flex items-center gap-1">
    {description} 
    {is_expired && (
      <span className="flex items-end text-red-500">
        <ErrorOutlineIcon fontSize="inherit" />
        expired
      </span>
    )}
  </span>

  <button
    style={{ borderRadius: "15px", cursor: "default", fontSize: "10px" }}
    className={`${
      currentSate ? "bg-black text-white" : "bg-customBlue text-white"
    } rounded-full w-[30%] py-1 px-2`}
  >
    {currentSate ? "Used" : "Not Used"}
  </button>
</div>
    </Card>
  );
}

export default CouponCard;
